import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ca-employee-selector" }
const _hoisted_2 = {
  key: 0,
  class: "selected-person-card mb-2"
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "fw-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "position-absolute top-50 end-0 translate-middle-y me-3"
}
const _hoisted_10 = {
  key: 1,
  class: "dropdown-menu show w-100 mt-1",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_13 = { class: "fw-semibold" }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "dropdown-item-text text-muted"
}

import { ref, watch, onBeforeUnmount } from "vue";
import { useDebounce } from "../../../../room-booking-management/calendar/composables/useDebounce";


export default {
  __name: 'CourseAppointmentEmployeeSelector',
  props: {
	form: { type: Object, required: true },
	employeeSearchApiUrl: { type: String, default: null },
	disabled: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const searchQuery = ref("");
const searchResults = ref([]);
const loading = ref(false);
const showDropdown = ref(false);
// Number/email of the currently selected employee (for the card), kept locally.
// The id/name themselves live in the form (employeeId/employeeName) and are rendered
// reactively via <form.Subscribe>, so the card survives prefill and edit population.
const selectedNumber = ref("");

const { debounce } = useDebounce();
const debouncedSearch = debounce(searchPersons, 300);

function handleSearchInput() {
	if (searchQuery.value.trim()) {
		debouncedSearch();
	} else {
		searchResults.value = [];
	}
}

async function searchPersons() {
	if (searchQuery.value.trim().length <= 1 || !props.employeeSearchApiUrl) {
		searchResults.value = [];
		return;
	}

	loading.value = true;
	try {
		const url = `${props.employeeSearchApiUrl}?q=${encodeURIComponent(searchQuery.value)}`;
		const response = await fetch(url, {
			method: "GET",
			headers: { Accept: "application/json" },
			credentials: "same-origin",
		});
		if (!response.ok) {
			throw new Error(`Search failed: ${response.status}`);
		}
		const data = await response.json();
		searchResults.value = (data.items || []).map((item) => ({
			id: item.id,
			name: item.name,
			number: item.employeeNumberWWU,
		}));
	} catch (error) {
		console.error("Employee search error:", error);
		searchResults.value = [];
	} finally {
		loading.value = false;
	}
}

function selectPerson(person) {
	selectedNumber.value = person.number || "";
	searchQuery.value = person.name;
	showDropdown.value = false;
	searchResults.value = [];
	props.form.setFieldValue("employeeId", person.id);
	props.form.setFieldValue("employeeName", person.name);
}

function clearSelection() {
	selectedNumber.value = "";
	searchQuery.value = "";
	searchResults.value = [];
	props.form.setFieldValue("employeeId", null);
	props.form.setFieldValue("employeeName", "");
}

// Close dropdown when clicking outside.
function handleClickOutside(event) {
	if (!event.target.closest(".ca-employee-selector")) {
		showDropdown.value = false;
	}
}
watch(showDropdown, (show) => {
	if (show) {
		document.addEventListener("click", handleClickOutside);
	} else {
		document.removeEventListener("click", handleClickOutside);
	}
});
onBeforeUnmount(() => document.removeEventListener("click", handleClickOutside));

const { form } = props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, " Fremdbuchung (Dozent*in) ", -1 /* CACHED */)),
    _createCommentVNode(" Read the current selection reactively from the form store (survives prefill/edit). "),
    _createVNode(_unref(form).Subscribe, null, {
      default: _withCtx(({ values }) => [
        _createCommentVNode(" Selected employee card "),
        (values.employeeId && values.employeeName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-user-check text-success me-2" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(values.employeeName), 1 /* TEXT */)
                  ]),
                  (selectedNumber.value)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(selectedNumber.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-danger",
                  disabled: __props.disabled,
                  onClick: clearSelection
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_6)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Search input (shown when no employee is selected) "),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((searchQuery).value = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Name oder E-Mail eingeben...",
                  disabled: __props.disabled,
                  onInput: handleSearchInput,
                  onFocus: _cache[1] || (_cache[1] = $event => (showDropdown.value = true))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8), [
                  [_vModelText, searchQuery.value]
                ]),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", {
                        class: "spinner-border spinner-border-sm",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Wird geladen...")
                      ], -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Search results dropdown "),
                (showDropdown.value && (searchResults.value.length > 0 || (searchQuery.value && !loading.value)))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (person) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: person.id,
                          type: "button",
                          class: "dropdown-item",
                          onClick: $event => (selectPerson(person))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(person.name), 1 /* TEXT */),
                              _createElementVNode("small", _hoisted_14, _toDisplayString(person.number), 1 /* TEXT */)
                            ])
                          ])
                        ], 8 /* PROPS */, _hoisted_11))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (searchQuery.value && searchResults.value.length === 0 && !loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(searchQuery.value.length > 1 ? 'Keine Ergebnisse gefunden' : 'Mindestens zwei Zeichen erforderlich'), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}